import React, { useState } from "react";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { format } from "date-fns";
import { API_BASE_URL } from "../../Config/Config";
import "./fee.css";

function StudentFee(dataClient) {
  const [excelData, setExcelData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  // const [uploadClicked, setUploadClicked] = useState(false);

  const user_name = dataClient.dataClient.client_schema_name[6][0].user_name;

  const handleFileUpload = (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];
    setFileName(file.name);

    // MIME types (Multipurpose Internet Mail Extensions) are standardized identifiers used to indicate the nature and format of a file
    const validMimeTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];

    if (!validMimeTypes.includes(file.type)) {
      setErrorMessage(`Error: Invalid selection. Please upload an Excel file (${file.name}).`);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      
      if (firstSheetName !== "ID Wise Fee Plan") {
        setErrorMessage(
          "Error: The uploaded file does not contain the required sheet name 'ID Wise Fee Plan'."
        );
        return;
      }

      const worksheet = XLSX.utils.sheet_to_json(
        workbook.Sheets[firstSheetName],
        { header: 1 }
      );
      const filteredData = worksheet.filter((row, index) => {
        if (index === 0) return true;
        return row.every(
          (cell) => cell !== undefined && cell !== null && cell !== ""
        );
      });
      setExcelData(filteredData);
      setErrorMessage("");
    };
    reader.readAsArrayBuffer(file);
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };

  const formatDate = (excelDate) => {
    if (isNaN(excelDate)) {
      return "";
    }
    const date = new Date((excelDate - (25567 + 2)) * 86400 * 1000);
    return format(date, "yyyy-MM-dd");
  };

  const handleSaveData = () => {
    if (excelData.length === 0) {
      Swal.fire({
        title: "Error",
        text: "Please upload an Excel file before saving fee details data",
        icon: "error",
        confirmButtonColor: "#318682",
      });
      return;
    }

    const expectedHeaders = [
      "ID",
      "Name ",
      "Batch",
      "From Status\r\n(Y=Yes)\r\n(N= NO)\r\n(F-P/P = Fee Plan Pending)",
      "Mobile Parent",
      "VALIDITY",
      "Net CF Dues ",
      "CF Recd ",
      "Net CF R/ble",
      "1st instal as per Fee plan",
      "Left in 1st",
      "Date of 1st Inst as per fee plan",
      "2nd instal",
      "Left in 2nd",
      "Date of 2nd Inst.",
      "3rd instal",
      "Left in 3rd",
      "Date of 3rd Inst.",
      "4th instal",
      "Left in 4th",
      "Date of 4th Inst.",
      "5th instal",
      "Left in 5th",
      "Date of 5th Inst.",
      "6th instal",
      "Left in 6th",
      "Date of 6th Inst.",
      "7th instal",
      "Left in 7th",
      "Date of 7th Inst.",
      "8th instal",
      "Left in 8th",
      "Date ",
      "9th install ",
      "Left in 9th",
      "Date ",
      "10th install ",
      "Left in 10th",
      "Date ",
      "11th install ",
      "Left in 11th",
      "Date ",
      "12th install ",
      "Left in 12th",
      "Remark",
    ];

    const uploadedHeaders = excelData[0];

    const missingHeaders = expectedHeaders.filter(
      (header) => !uploadedHeaders.includes(header)
    );

    if (missingHeaders.length > 0) {
      Swal.fire({
        title: "Error",
        text: `The uploaded file is missing the following required columns: ${missingHeaders.join(
          ", "
        )}`,
        icon: "error",
        confirmButtonColor: "#318682",
      });
      return;
    }

    const formattedData = excelData.slice(1).map((row) => ({
      roll_number: String(row[0]),
      name: String(row[1]),
      batch: String(row[2]),
      from_status: String(row[3]),
      mobile_parent: String(row[4]),
      validity: formatDate(row[5]),
      net_cf_dues: row[6],
      cf_recd: row[7],
      net_cf_receivable: row[8],
      i_instal: row[9],
      left_in_1st: row[10],
      date_of_1st_inst: formatDate(row[11]),
      ii_instal: row[12],
      left_in_2nd: row[13],
      date_of_2nd_inst: formatDate(row[14]),
      iii_instal: row[15],
      left_in_3rd: row[16],
      date_of_3rd_inst: formatDate(row[17]),
      iv_instal: row[18],
      left_in_4th: row[19],
      date_of_4th_inst: formatDate(row[20]),
      v_instal: row[21],
      left_in_5th: row[22],
      date_of_5th_inst: formatDate(row[23]),
      vi_instal: row[24],
      left_in_6th: row[25],
      date_of_6th_inst: formatDate(row[26]),
      vii_instal: row[27],
      left_in_7th: row[28],
      date_of_7th_inst: formatDate(row[29]),
      viii_instal: row[30],
      left_in_8th: row[31],
      date_of_8th_inst: formatDate(row[32]),
      ix_install_: row[33],
      left_in_9th: row[34],
      date_of_9th_inst: formatDate(row[35]),
      x_install: row[36],
      left_in_10th: row[37],
      date_of_10th_inst: formatDate(row[38]),
      xi_install: row[39],
      left_in_11th: row[40],
      date_of_11th_inst: formatDate(row[41]),
      xii_install: row[42],
      left_in_12th: row[43],
      date_of_12th_inst: formatDate(row[44]),
      remark: String(row[45]),
      created_on: "",
      created_by: user_name,
    }));

    fetch(`${API_BASE_URL}/coaching-collaborator-api/api/v1/fee-structures`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formattedData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "200") {
          Swal.fire({
            title: "Success",
            text: data.message,
            icon: "success",
            confirmButtonColor: "#318682",
          }).then(() => {
            window.location.reload();
          });
        } else if (data.status === "404") {
          Swal.fire({
            title: "Error",
            text: data.message,
            icon: "warning",
            confirmButtonColor: "#318682",
            html: `<pre class="swal2-custom-html">${data.errors}</pre>`,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        Swal.fire({
          title: "Error",
          text: "Failed to save data. Please check your input and try again.",
          icon: "error",
          confirmButtonColor: "#318682",
        });
      });
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">Student Fees</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSaveData}>
            SAVE
          </button>
        </div>
      </div>
      <div className="personal-info">
        <div className="personal-header">
          <div className="header">
            <h2>Student Fees Upload</h2>
          </div>
        </div>
        <div className="accordion-content">
          <div className="schedule-time-container" style={{ display: "flex" }}>
            <input
              type="file"
              accept=".xlsx"
              onChange={handleFileUpload}
              style={{ display: "none" }}
              id="excel-upload"
            />
            <label htmlFor="excel-upload">
              <button
                className="upload-excel-button"
                onClick={() => document.getElementById("excel-upload").click()}
              >
                Browse
              </button>
            </label>
            <input
              type="text"
              value={fileName ? fileName : ""}
              readOnly
              className="upload-excel-file-name"
            />
          </div>
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
      </div>
    </div>
  );
}

export default StudentFee;
